import PasswordInput from '@perpay-web/components/base/PasswordInput/PasswordInput';
import { withFormikInputWrapper } from '@perpay-web/components/higher-order/WithFormikInputWrapper/WithFormikInputWrapper';

const FormikPasswordInput = withFormikInputWrapper(PasswordInput);

/**
 * @type { any }
 */
export default FormikPasswordInput;
